import { render } from "./AddPracticeWithDoctor.vue?vue&type=template&id=0d9cf645"
import script from "./AddPracticeWithDoctor.vue?vue&type=script&lang=js"
export * from "./AddPracticeWithDoctor.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__